<div (click)="open = !open" [ngClass]="{open: open, invalid: !valid}">
	{{ value ? (label ? value[label] : value) : "" }}
</div>
<ul [ngClass]="{open: open}">
	<li *ngFor="let option of options" (click)="select(option)" [ngClass]="{active: option === value}">
		{{ label ? option[label] : option }}
	</li>
</ul>
